import { BusDevDepartments } from 'constants/enums';
import { FIRST_PAGE_INDEX, MAX_PAGE_SIZE } from 'constants/uiSettings';

export const CLIENT_WORKSPACE_PREFIX = '/cw';
export const HOST_US = import.meta.env.VITE_API_HOST_US;
export const HOST_EU = import.meta.env.VITE_API_HOST_EU;
export const CHATBOT_HOST_US = import.meta.env.VITE_CHATBOT_API_HOST_US;
export const CHATBOT_HOST_EU = import.meta.env.VITE_CHATBOT_API_HOST_EU;
export const JOIN_HOST = import.meta.env.VITE_JOIN_HOST;
export const SHARED_HOST = import.meta.env.VITE_SHARED_HOST;

export const EDGE = '/edge/clients';
export const LOGIN = `${EDGE}/login`;
export const SIGNUP = `${EDGE}/signup`;
export const CHECK_EMAIL = `${EDGE}/checkEmail`;
export const RESET_PASSWORD = `${EDGE}/resetPassword`;
export const UPDATE_PASSWORD = `${EDGE}/password`;
export const SETUP_PASSWORD = `${EDGE}/setup_password`;

export const USER = `${CLIENT_WORKSPACE_PREFIX}/user`;
export const GET_USER = `${USER}/me`;
export const GET_USER_LIST = `${USER}/list`;
export const GUIDE = `${USER}/config/guide`;
export const USER_PLATFORM_LANGUAGE = `${USER}/platform-language`;

export const TALENT_ACQUISITION_AND_ACE = `${USER}/list?page=${FIRST_PAGE_INDEX}&pageSize=${MAX_PAGE_SIZE}&department=${BusDevDepartments.TalentAcquisitionAndAce}`;
export const NOTIFICATIONS = `${USER}/notifications`;
export const NOTIFICATIONS_COUNT = `${NOTIFICATIONS}/count`;
export const NOTIFICATIONS_READ = `${NOTIFICATIONS}/read`;

export const CLIENT = `${CLIENT_WORKSPACE_PREFIX}/client`;
export const CLIENTS_PAGE = `${CLIENT_WORKSPACE_PREFIX}/clients`;
export const CLIENTS = `${CLIENT}/list`;
export const CLIENTS_IDS = `${CLIENTS}/ids`;
export const CLIENTS_ALL_BUSDEV = `${USER}/list?page=${FIRST_PAGE_INDEX}&pageSize=${MAX_PAGE_SIZE}&department=${BusDevDepartments.SalesAndBusinessDevelopment}`;
export const CLIENTS_BULK = `${CLIENT}/bulk`;
export const CLIENTS_STAGE_BULK = `${CLIENTS_BULK}/stage`;
export const CLIENTS_NEXT_CONTACT_DATE_BULK = `${CLIENTS_BULK}/next_contact_date`;
export const CLIENTS_LAST_CONTACT_DATE_BULK = `${CLIENTS_BULK}/last_contact_date`;
export const CLIENTS_BUS_DEV_BULK = `${CLIENTS_BULK}/busdev`;
export const CLIENT_PAYMENT_METHODS = `${CLIENT}/payment_methods`;

export const WORKSPACE = '/workspace';
export const CLIENTS_WORKSPACE_HOME = `${CLIENT}${WORKSPACE}/home`;
export const CLIENTS_WORKSPACE_USER = `${CLIENT}${WORKSPACE}/user`;
export const MANAGE_JOB = `${CLIENT_WORKSPACE_PREFIX}/job`;
export const FREE_JOBS_INFO = `${MANAGE_JOB}/free_jobs_info`;
export const REGISTRATION_METRICS = `${CLIENTS_WORKSPACE_HOME}/registration_metrics`;

export const OPEN = '/open';
export const CITIES = `${OPEN}/cities`;
export const STATES = `${OPEN}/used_states`;
export const CITIES_BY_STATE_OR_COUNTRY = `${OPEN}/used_cities`;
export const DICT = `${OPEN}/dict`;
export const COUNTRIES = `${OPEN}/countries`;
export const FEEDBACK = `${OPEN}/feedback`;

export const WORK_EXPERIENCE = '/work_experience';
export const EDUCATION = '/education';
export const DECLINE = '/decline';
export const COMPLETE = '/complete';
export const JOB_PART = '/job';
export const MATCHES = '/matches';
export const INVITE = '/invite';
export const EDUCATION_AND_WORK_EXPERIENCE = '/experience';

export const JOB = `${CLIENT_WORKSPACE_PREFIX}/job`;
export const JOB_LIST = `${JOB}/list`;
export const JOBS_IDS = `${JOB_LIST}/ids`;
export const CLIENT_JOBS = `${JOB}/client`;
export const JOBS_BULK = `${JOB}/bulk`;
export const JOBS_COUNTRIES = `${JOB}/countries`;
export const JOBS_STAGE_BULK = `${JOBS_BULK}/stage`;
export const JOBS_JOBLIO_CONTACT_BULK = `${JOBS_BULK}/joblio_contact`;

export const RESOURCE = `/resources/attachments`;
export const RESOURCE_PUBLIC = `${RESOURCE}/public/`;

export const APPLICATION = `${CLIENT_WORKSPACE_PREFIX}/application`;
export const APPLICATIONS = `${APPLICATION}/list`;
export const APPLICATIONS_IDS = `${APPLICATION}/list/ids`;
export const APPLICATIONS_BULK = `${APPLICATION}/bulk`;
export const APPLICATIONS_COUNTRIES = `${APPLICATION}/countries`;
export const APPLICATIONS_START_DATE_BULK = `${APPLICATIONS_BULK}/start_date`;
export const APPLICATIONS_STAGE_BULK = `${APPLICATIONS_BULK}/stage`;
export const APPLICATIONS_SEPARATION_DATE_BULK = `${APPLICATIONS_BULK}/separation_date`;
export const APPLICATIONS_INVOICE_SENT_DATE_BULK = `${APPLICATIONS_BULK}/invoice_sent_date`;
export const APPLICATIONS_INVOICE_SENT_BULK = `${APPLICATIONS_BULK}/invoice_sent`;
export const APPLICATION_JOBS_DICTIONARY = `${APPLICATION}/jobs/dictionary`;
export const OFFER_LETTER = 'offer_letter';
export const OFFER_LETTER_SEND = 'offer_letter_send';
export const WITHDRAW = 'withdraw';

export const JOBSEEKER = `${CLIENT_WORKSPACE_PREFIX}/jobseekers`;
export const JOBSEEKERS = `${JOBSEEKER}/list`;
export const JOBSEEKERS_IDS = `${JOBSEEKERS}/ids`;
export const JOBSEEKERS_FACET = `${JOBSEEKER}/facet`;
export const JOBSEEKERS_SEARCH = `${JOBSEEKER}/search`;
export const JOBSEEKER_APPLICATIONS = `${APPLICATION}${JOBSEEKER}`;
export const JOBSEEKERS_COUNTRIES = `${JOBSEEKER}/countries`;
export const JOBSEEKERS_HOST_COUNTRY = `${JOBSEEKER}/hostCountry`;
export const JOBSEEKERS_BULK = `${JOBSEEKER}/bulk`;
export const JOBSEEKERS_STAGE_BULK = `${JOBSEEKERS_BULK}/stage`;
export const JOBSEEKERS_RECRUITER_BULK = `${JOBSEEKERS_BULK}/recruiter`;
export const JOBSEEKERS_IMMIGRATION_ROUTE_BULK = `${JOBSEEKERS_BULK}/immigration_route`;
export const JOBSEEKERS_CONTACT_DATE_BULK = `${JOBSEEKERS_BULK}/contact_date`;
export const JOBSEEKERS_INVITE_BULK = `${JOBSEEKERS_BULK}${INVITE}`;
export const COMMENT = `${JOBSEEKER}/comment`;
export const COMMENTS = `${COMMENT}/list`;

export const AMBASSADOR = `${CLIENT_WORKSPACE_PREFIX}/ambassador`;
export const AMBASSADORS = `${AMBASSADOR}/list`;

export const CONFIRM = '/confirm';

export const REPORTS = `${CLIENT_WORKSPACE_PREFIX}/report`;
export const RECRUITMENT_OVERVIEW_REPORT_STAT = `${REPORTS}/hiring/stat`;
export const RECRUITMENT_OVERVIEW_REPORT_CITIES = `${RECRUITMENT_OVERVIEW_REPORT_STAT}/used_locations`;
export const RECRUITMENT_OVERVIEW_REPORT_JOBS = `${RECRUITMENT_OVERVIEW_REPORT_STAT}/jobs`;
export const CLOSED_HIRES = 'closed_hires';

export const PAYMENT_METHODS = `${CLIENT}/payments_method_set`;
export const CLIENT_SECRET = `${CLIENT}/client_secret`;

export const JOB_DESCRIPTION_WEBSOCKET = '/ws/cw';
